import { create } from "zustand";
import type { WorkflowErrorLog, WorkflowExecutionLog } from "./workflow-log.types";

type WorkflowLogState = {
	executionLogs: WorkflowExecutionLog[];
	errorLogs: WorkflowErrorLog[];
	setExecutionLogs: (logs: WorkflowExecutionLog[]) => void;
	setErrorLogs: (errors: WorkflowErrorLog[]) => void;
	clear: () => void;
};

export const useWorkflowLogStore = create<WorkflowLogState>((set) => ({
	executionLogs: [],
	errorLogs: [],
	setExecutionLogs: (executionLogs) => set({ executionLogs }),
	setErrorLogs: (errorLogs) => set({ errorLogs }),
	clear: () => set({ executionLogs: [], errorLogs: [] }),
}));
